import { apiSlice } from "../api/apiSlice";
import {
  BuildingFloorEntranceAction,
  PropertyUnitsCountAction,
  CurrentOwnerDetailByContractIdAction,
  ContractOwnerAndRenterDetailsAction,
  PropertyUnitsDetailAction
} from "./buildingslice";
// import { toast } from "react-toastify";

export const buildingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPropertyFloorEntrance: builder.query({
      query: ({ propertyid, type }) =>
        `Keyfree/GetPropertyFloorEntrance?propertyid=${propertyid ?? ""}&type=${
          type ?? ""
        }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data.data) {
            dispatch(
              BuildingFloorEntranceAction({
                BuildingFloorEntranceList: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),
    getPropertyUnitsCountForCompany: builder.query({
      query: ({ companyId }) =>
        `Keyfree/getPropertyUnitsCountForCompany?companyId=${
            companyId ?? ""
          }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data.data) {
            dispatch(
              PropertyUnitsCountAction({
                PropertyUnitsCount: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    getCurrentOwnerDetailByContractId: builder.query({
      query: ({ contractId }) =>
        `Keyfree/getCurrentOwnerDetailByContractId?contractId=${
          contractId ?? ""
          }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          //console.log('getCurrentOwnerDetailByContractId - ', result);
          if (result.data.data) {
            dispatch(
              CurrentOwnerDetailByContractIdAction({
                CurrentOwnerDetailByContractId: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    getContractOwnerAndRenterDetails: builder.query({
      query: ({ ContractId, PropertyUnitId }) =>
        `Keyfree/getContractOwnerAndRenterDetails?ContractId=${ContractId ?? ""}&PropertyUnitId=${
          PropertyUnitId ?? ""
        }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          //console.log('getContractOwnerAndRenterDetails - ', result);
          if (result.data.data) {
            dispatch(
              ContractOwnerAndRenterDetailsAction({
                ContractOwnerAndRenterDetails: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

    getPropertyUnitDetails: builder.query({
      query: ({ PropertyUnitId }) =>
        `Keyfree/GetPropertyUnitDetails?propertyUnitId=${
          PropertyUnitId ?? ""
        }`,
      async onQueryStarted(args, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result.data.data) {
            dispatch(
              PropertyUnitsDetailAction({
                PropertyUnitsDetail: result.data.data,
              })
            );
          }
        } catch (err) {}
      },
    }),

  }),
  
});

export const {
  useLazyGetPropertyFloorEntranceQuery,
  useLazyGetPropertyUnitsCountForCompanyQuery,
  useLazyGetCurrentOwnerDetailByContractIdQuery,
  useLazyGetContractOwnerAndRenterDetailsQuery,
  useLazyGetPropertyUnitDetailsQuery
} = buildingApi;
